import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './_store'
import 'ant-design-vue/dist/antd.min.css'

import VueI18n from 'vue-i18n'
import sharedMessage from './locales'
import moment from 'moment'
import {default as notification} from 'ant-design-vue/es/notification'
import VueMatchHeights from 'vue-match-heights/src'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.prototype.$notification = notification
Vue.prototype.moment = moment
Vue.use(VueI18n)
Vue.use(VueMatchHeights, {
  disabled: [768]
})
const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: sharedMessage
})
Vue.config.productionTip = false
let uri = window.location.search.substring(1)
let params = new URLSearchParams(uri)

if (sessionStorage.length === 0 || sessionStorage.ssid !== params.get('ch')) {
  if (params.get('ch')) {
    if (params.get('ch').length !== 0) { sessionStorage.setItem('ssid', params.get('ch')) }
  }
  if (params.get('uid')) {
    if (params.get('uid').length !== 0) { sessionStorage.setItem('uid', params.get('uid')) }
  }
}

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js